// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"4701":"svg-icons","8177":"remix-icons","9222":"blueprint-icons"}[chunkId] || chunkId) + "." + {"2792":"b067d087","4529":"1baf96f3","4701":"e81934d6","6926":"52bd5fa2","6994":"71f155d9","8177":"36ac7c61","8749":"7c3a0def","9222":"dda5a7c9"}[chunkId] + ".chunk.js";
};